/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_HintInputs */

const vi_einvoice_draft_hint = /** @type {(inputs: Einvoice_Draft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bước tiếp theo: mở Xem nháp để kiểm tra, sau đó chọn Xuất bản.`)
};

/**

* @param {Einvoice_Draft_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_hint = /** @type {((inputs?: Einvoice_Draft_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_hint(inputs)
});